import styled from 'styled-components';

export const ListStyled = styled.ul`
  border-top: 1px solid rgb(239, 239, 239);
  border-bottom: 1px solid rgb(239, 239, 239);
  padding: 24px 24px 10px;
  max-height: calc(-450px + 100vh);
  height: 100%;
  overflow-y: scroll;
  width: 100%;
`;

export const ItemStyled = styled.li`
  background-color: rgb(249, 249, 251);
  margin-bottom: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  cursor: pointer;
  border-bottom: none !important;
  overflow: hidden;

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 8px 0;
  }

  p {
    margin: 8px 0;
  }

  strong,
  b {
    font-weight: 600;
  }

  em,
  i {
    font-style: italic;
  }

  * {
    max-width: 100% !important;
  }

  &:hover {
    background-color: #f3f3f5;
  }
`;

export const NoQuestionFindArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 380px);

  > p {
    font-family: DM Sans, sans-serif;
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 25px;
    letter-spacing: 1%;
    text-align: center;
    vertical-align: middle;
    color: #434343;
  }
`;

export const CleanButton = styled.button`
  width: fit-content;
  height: fit-content;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #d6d6d6;
  box-shadow: 0px 1px 2px 0px #1212170d;
  background: transparent;
  cursor: pointer;

  font-family: Manrope, sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 3%;
  color: #101010;

  margin-top: 20px;
`;
